import React, { useContext } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import BannerSection from "../BannerSection";
import Header from "../Header";
import Footer from "./Footer";
import { KBContext } from "../../Context";
import { NewCategoryLoader } from "../Loaders/NewCategoryLoader";
import AdminFooter from "../AdminFooter";
import { isFeatureEnabled } from "../../utils";
import { poweredByHiver } from "../../Constants";

const Wrapper = styled.div`
  --kb-content-max-width: 1280px;
  --kb-content-padding-x: 48px;
  --kb-content-inner-width: calc(var(--kb-content-max-width, 1280px) - 2 * var(--kb-content-padding-x, 48px));
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 32px 256px 55px 256px;
  @media (max-width: 1400px) {
    padding: 32px 160px 100px 160px;
  }
  @media (max-width: 1100px) {
    --kb-content-padding-x: 64px;
    padding: 32px 96px 60px 96px;
  }
  @media (max-width: 778px) {
    --kb-content-padding-x: 40px;
    padding: 32px 48px 40px 48px;
  }
  @media (max-width: 500px) {
    padding: 32px 32px 30px 32px;
  }
`;

const MainContent = styled.main`
  width: 100%;
  padding: 0;
  padding-bottom: ${(props) => (props.$isProductPage ? "100px" : "100px")};
`;

const ContentColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

export default function Layout(props) {
  const [searchParams] = useSearchParams();
  const { data, showDashboardFooter, availableFeatures } = useContext(KBContext);
  const showPoweredByHiverFooter = isFeatureEnabled(poweredByHiver, availableFeatures);
  const isProductPage = searchParams.get("product") === "product";

  if (data) {
    return (
      <Wrapper
        tabIndex="-1"
        id="mainWrapper"
      >
        <ContentColumn>
          <Header bannerData={data} />
          <MainContent $isProductPage={isProductPage}>
            <BannerSection bannerData={data} />
            <div style={{ marginBottom: 0 }}>
              {props.children}
            </div>
          </MainContent>
        </ContentColumn>
        {showPoweredByHiverFooter && <Footer />}
        {showDashboardFooter ? <AdminFooter /> : ""}
      </Wrapper>
    );
  }
  return <NewCategoryLoader />;
}
